export const TEXT_INFORMATION_SECTIONS = [
  {
    heading: 'How do I update my text message preferences?',
    text: `To make changes to your preferences, click on the individual preference options
      and press “Save Changes.” Once you have confirmed your consent to receive text messages from The Home Depot,
      you will be sent a text message. You will be given information about how to opt into (and out of)
      those programs at the time you sign up for them.`,
  },
  {
    heading: 'How do I unsubscribe from text messages?',
    text: `To unsubscribe from future text messages from The Home Depot, you can unselect the
           options and press “Save Changes”, reply “STOP” to the text messages, or call 1-877-
           467-3409.`,
  },
  {
    heading: 'Additional Promotional Text Message Details',
    text: `Please note that your consent to participate in the programs listed here will be treated
          separately from your consent to participate in any of our other non-marketing programs.`,
  }
];

export const EMAIL_INFORMATION_SECTIONS = [
  {
    heading: 'How do I update my email preferences?',
    text: `To make changes to your preferences, click on the individual preference options
      and press “Save Changes.”`,
  },
  {
    heading: 'How do I unsubscribe from emails?',
    text: `To unsubscribe from future promotional emails from The Home Depot, unselect the email options.
      Please note, that on occasion you may receive transactional communications from The Home Depot.`,
  },
  {
    heading: 'Additional Promotional Email Details',
    text: `Please note that your consent to participate in the programs listed will be treated separately
      from your consent to participate in any of our other programs.`,
  },
];
